
<div >
    <mat-form-field  *ngIf="rolesSelected().length>0">
        <mat-label>Ruoli</mat-label>
        <mat-select  [(value)]="selected" (selectionChange)="changeRole()">
            <ng-container *ngFor="let ruolo of rolesSelected()" >
            <mat-option  [value]="ruolo?.id" >
              {{ruolo.name}}
            </mat-option>
            </ng-container>
        </mat-select>
      </mat-form-field>
</div>

